export default "__VITE_ASSET__canMoxMt_hnyV9pVRD$Ikw__"